const ePhaseTypes = {
  PICKUP: 1,
  NONSTANDART: 2,
  COMBINATION: 3,
};
const phaseTypeTitles = ["Заезд", "Нестандарт", "Свозка"];

export {
  ePhaseTypes,
  phaseTypeTitles,
};